import * as React from 'react';
import {useState} from 'react';
import {Button, Loader} from '@flexe/ui-components';

const PrintLPNsTab: React.FC = () => {
  const [numberOfLabels, setNumberOfLabels] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const isValidNumber = (numLabelStr: string): boolean => {
    const numLabels: number = parseInt(numLabelStr, 10);
    return numLabels > 0 && numLabels <= 99;
  };

  const handleGenerateLabels = () => {
    if (!isValidNumber(numberOfLabels)) {
      setError('Please enter a positive number between 1 and 99.');
      return;
    }

    setError(null);

    try {
      window.open('/api/v2/lpns/generate/' + numberOfLabels + '.pdf', '_blank');
      setNumberOfLabels('');
    } catch (e) {
      setError('Failed to generate LPN labels. Please try again.');
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newVal = event.target.value;
    setNumberOfLabels(newVal);
    if (newVal === '' || isValidNumber(newVal)) {
      setError(null);
    } else {
      setError('Please enter a positive number between 1 and 99.');
    }
  };

  const hasError = (): boolean => {
    return error !== null;
  };

  return (
    <div className="print-lpns-tab">
      <div className="form-group">
        <label className="form-control-label" htmlFor="generate-lpn-input">
          # of Labels
        </label>
        <input
          type="number"
          id="generate-lpn-input"
          className="form-control"
          value={numberOfLabels}
          onChange={handleChange}
          min="1"
          max="99"
        />
      </div>
      <div className={'col-md-12' + (hasError() ? ' alert alert-danger' : '')}>
        <span id="generate-lpn-error">{error}</span>
      </div>

      <Button
        onPress={handleGenerateLabels}
        visualType="primary"
        isDisabled={hasError() || numberOfLabels === '' || parseInt(numberOfLabels, 10) < 1}
      >
        Generate LPN Labels
      </Button>
    </div>
  );
};

export default PrintLPNsTab;
